const config = {
    apiEndpoint: "https://kasincoffee.work.gd:613/api",
    uploadEndpoint: "https://kasincoffee.work.gd:613/uploads",
  };
  
  export default config;